import React from "react";
import { useNavigate } from "react-router-dom";

export default function Loader() {
  const navigate = useNavigate();
  setTimeout(() => {
    navigate("/home");
  }, 4400);
  return (
    <div className="loader">
      <div className="text" data-text="Supix...">
        Supix...
      </div>
    </div>
  );
}
